import PropTypes from 'prop-types';

import { FocusGrid, HubContainerGridStyled, HubMainWrapperStyled } from '#client/components/Grid';

export default function PageWrapper({ children }) {
  return (
    <HubContainerGridStyled>
      <FocusGrid>
        <HubMainWrapperStyled>{children}</HubMainWrapperStyled>
      </FocusGrid>
    </HubContainerGridStyled>
  );
}

PageWrapper.propTypes = {
  children: PropTypes.node.isRequired
};
